import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

export const isRefactorNinToViewSchemaEnabled = (): boolean =>
	// eslint-disable-next-line jira/ff/no-preconditioning
	expVal('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) &&
	fg('refactor_nin_to_jira_view_schema');
